import React from 'react';
import { Flex, Link, Text } from '@amzn/storm-ui';
import { FooterLinkMobile, MobileLinksWrapper } from './Footer.styles';
import { FooterComponentProps } from './Footer.types';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

const Mobile: React.VFC<FooterComponentProps> = ({
  copyright,
  links,
  toggleText,
  toggleView,
  isFooterLinkEnabled,
}) => (
  <Flex
    id="footer"
    direction="column"
    justifyContent="center"
    alignItems="center"
    rowGap="xxsmall"
  >
    {isFooterLinkEnabled === true && toggleText && toggleView && (
      <Link onClick={toggleView}>{toggleText}</Link>
    )}
    <Text color="secondary">{copyright}</Text>
    {links.length > 0 && (
      <MobileLinksWrapper
        direction="column"
        alignItems="center"
        justifyContent="center"
        rowGap="xxsmall"
      >
        {links.map((link) => (
          <FooterLinkMobile
            key={link.label}
            href={link.url}
            {...getTaktAttributes('link', chromeComponents.FOOTER, {
              url: link.url,
              label: link.label,
            })}
          >
            {link.label}
          </FooterLinkMobile>
        ))}
      </MobileLinksWrapper>
    )}
  </Flex>
);

export default Mobile;
